import ReturnsDesktop from './ReturnsDesktop';
import { withI18n } from 'react-i18next';

export default withI18n()(ReturnsDesktop);
